import { ReactComponent as LogoInstagramIcon } from 'assets/images/instagram-logo.svg';
import { ReactComponent as LogoMessengerIcon } from 'assets/images/logo-messenger.svg';
import { ReactComponent as LogoTelegramIcon } from 'assets/images/logo-telegram.svg';
import { ReactComponent as LogoWhatsappIcon } from 'assets/images/logo-whatsapp-nova.svg';
import { ReactComponent as LogoWhatsappOficialIcon } from 'assets/images/logo-whatsapp-oficial.svg';
import { ReactComponent as LogoWhatsAppHybridIcon } from 'assets/images/whatsapp-hybrid.svg';
import { TipoCanalTypes } from 'store/reducers/canais';

/** Icons tipos canais */

export default function getIconTipoCanal({
  tipoCanal,
  size,
  isModoHibrido,
}: {
  tipoCanal: TipoCanalTypes;
  size?: number;
  isModoHibrido?: boolean;
}) {
  if (isModoHibrido) {
    return <LogoWhatsAppHybridIcon style={{ width: size, height: size }} />;
  }

  switch (tipoCanal) {
    case 'WHATSAPP':
      return <LogoWhatsappIcon style={{ width: size, height: size }} />;
    case 'TELEGRAM':
      return <LogoTelegramIcon style={{ width: size, height: size }} />;
    case 'MESSENGER':
      return <LogoMessengerIcon style={{ width: size, height: size }} />;
    case 'WHATSAPP_OFICIAL':
      return <LogoWhatsappOficialIcon style={{ width: size, height: size }} />;
    case 'INSTAGRAM':
      return <LogoInstagramIcon style={{ width: size, height: size }} />;
    default:
      return null;
  }
}
